import '../styles/main.scss';
import '../gutenberg/document-settings/EpisodeNumber';
import '../gutenberg/document-settings/EpisodeDuration';
import '../gutenberg/document-settings/VideoPlayer';
import '../gutenberg/blocks/podcast-description';
import '../gutenberg/blocks/podcast-content';
import DisplayComponent from '../gutenberg/components/DisplayComponent';
import waitFor from '../gutenberg/utils/waitFor';

const { registerPlugin } = wp.plugins;

wp.domReady(() => {
	waitFor(
		'.edit-post-header__settings',
		() => {
			registerPlugin('ib-wow-podcast', {
				icon: 'editor-paragraph',
				render: DisplayComponent,
			});
		},
		true,
	);
});
